import React, { useEffect } from 'react'
import './HomePageLayout.css'
import { ConfigurationDashboardNavbar } from '../configurationDashboardNavbar/configurationDashboardNavbar'
import { resetConfigDashboardTypes, setActiveConfigType, updateActiveConfigType } from '../../stateManagement/actions/configDashboardActions'
import { ConfigDashboardTypes } from '../../types'
import { getConfigurationTypes } from '../../services/uiConfigService'
import store from '../../stateManagement/store'
import SimpleBar from 'simplebar-react'
import "simplebar-react/dist/simplebar.min.css";

function HomePageLayout({children , resetNavOptions, pageId}: {children? : JSX.Element , resetNavOptions?:boolean, pageId?:string}) {
  useEffect(() => {
    async function getNavbarConfigTypes(){
      const layoutConfig = store.getState()?.portalConfigState?.layoutConfig ?? [];
      const configTypes = (layoutConfig.find((configObj) => configObj.name === "mainDashboardLayout")?.value ?? []);
      resetConfigDashboardTypes({configDashboardTypes:configTypes})
    }
    if(resetNavOptions !== false){ 
      setActiveConfigType("");
    }
    getNavbarConfigTypes();
    if(resetNavOptions === false && pageId){
      updateActiveConfigType(pageId)
    }
  },[])
  return (
    <div className='homePageContainer'>
        <ConfigurationDashboardNavbar />
        <div className='homePageInnerComponentContainer'>
            <SimpleBar className='homePageInnerComponent'>
            {children}
            </SimpleBar>
        </div>
    </div>
  )
}

export default HomePageLayout;